module.exports = __webpack_public_path__ + "static/media/ArrowUpIconDetails.64bb5abe.svg";